var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fa38818d-f03b-4982-9add-fb5a8e4910d2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-b3ef9b66-b3ca-490b-b48d-e60a35cf62fc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.38,2.24l-1.16-1.65c-.26-.37-.69-.59-1.14-.59H7.87c-.46,0-.88,.22-1.14,.59l-1.16,1.65H1.29c-.71,0-1.29,.57-1.29,1.27V13.73c0,.7,.58,1.27,1.29,1.27H19.71c.71,0,1.29-.57,1.29-1.27V3.51c0-.7-.58-1.27-1.29-1.27h-4.32Zm-4.88,11.24c-2.89,0-5.23-2.3-5.23-5.15S7.61,3.19,10.5,3.19s5.24,2.3,5.24,5.14-2.34,5.15-5.24,5.15Z",
    style: {
      fill: "#3c3d3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.83,8.33c0,1.81-1.49,3.28-3.33,3.28s-3.33-1.47-3.33-3.28,1.49-3.27,3.33-3.27,3.33,1.47,3.33,3.27Z",
    style: {
      fill: "#3c3d3e"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.c3eed1f26e0951df72b32a4415bc9e93.svg";
export { ForwardRef as ReactComponent };